function LangMenu(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var menuVisible = false;
	var menu;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			menu = $('ul', _this.container);
			
			_this.container.mouseenter(function(e) {
				if(!menuVisible){
					_this.show();
				}
			});
			_this.container.mouseleave(function(e) {
				if(menuVisible){
					_this.hide();
				}
			});
			
			_this.inited = true;
		}
	};
	
	
	this.show = function(){
		menu.addClass('visible');
		menuVisible = true;
	};
		
	
	this.hide = function(){
		menu.removeClass('visible');
		menuVisible = false;	
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
